module.exports = __webpack_public_path__ + "img/UP380C&BT5.pic.c52d7bd9.png";